import * as Yup from 'yup';

/**
 * =====================================================
 * Type: LoginValues
 * =====================================================
 *
 * Description:
 * Defines the shape of the login form values.
 *
 * Fields:
 * - identifier: string representing either email or username
 * - password: string representing the user's password
 *
 * Author: Samano CASTRE
 * Date: February 1, 2026
 */

export type LoginValues = {
    identifier : string,
    password : string
}

/**
 * =====================================================
 * Initial Form Values
 * =====================================================
 *
 * Description:
 * Default values used to initialize the login form.
 */
export const logInInitValues = {
    identifier: '',
    password: '',
};

/**
 * =====================================================
 * Validation Schema
 * =====================================================
 *
 * Description:
 * Defines Yup validation rules for the login form.
 *
 * Rules:
 * - identifier must be a valid email OR a username longer than 5 characters
 * - password must have a minimum of 6 characters
 *
 * Notes:
 * - Custom test function used to combine email and username validation
 * - Provides human-readable validation messages
 */
export const loginValidationSchema = Yup.object({
    identifier: Yup.string()
        .test(
            'is-email-or-username',
            'Un e-mail valide ou un pseudo à 5 caractères.',
            function (value) {
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                return !!value && (emailRegex.test(value) || value.trim().length > 5);
            }
        )
        .required("l'identifiant est requis"),
    password: Yup.string()
        .min(6, '6 caractères minimum')
        .required('Le mot de passe est requis.'),
});